import { AxiosInstance, AxiosResponse } from 'axios';
import { TRecommendationsPOST, TRecommendationsResponse } from '@com/core/common/types/recommendation';
import { TLocaleAPI } from '../types/locale';

export type TRecommendationEndpoints = {
    ingest: (
        event: TRecommendationsPOST['event'],
        params: TRecommendationsPOST,
    ) => Promise<AxiosResponse<TRecommendationsResponse>>;
};

export default (api: AxiosInstance, apiLocale: TLocaleAPI): TRecommendationEndpoints => {
    const ingest = async (
        event: TRecommendationsPOST['event'],
        params: TRecommendationsPOST,
    ): Promise<AxiosResponse<TRecommendationsResponse>> =>
        api.post(`/_svc/recapi/ingest/${event}`, params, { headers: { 'x-locale': apiLocale } });

    return { ingest };
};
